const FormLabel = ({ htmlFor, label, required }) => (
  <label htmlFor={htmlFor}>
    {label} {required && <span style={{ color: "red" }}>*</span>}
  </label>
);

export default FormLabel;